import(/* webpackMode: "eager" */ "/home/u650493134/domains/kelolify.com/hbuilds/source/src/app/global-error.tsx");
